var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDepositGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#deposit-gold_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  x: 1,
  fill: "url(#deposit-gold_svg__b)",
  rx: 13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#161639",
  d: "M9.5 19 8 17.5 18.5 7 20 8.517zm8 .25a2.93 2.93 0 0 1-1.508-.4 3.16 3.16 0 0 1-1.084-1.083 2.9 2.9 0 0 1-.408-1.517q0-.816.417-1.5.416-.684 1.1-1.092a2.84 2.84 0 0 1 1.483-.408q.825 0 1.508.408a3 3 0 0 1 1.084 1.084q.408.675.408 1.508a2.9 2.9 0 0 1-.408 1.517q-.4.674-1.084 1.083a2.93 2.93 0 0 1-1.508.4m0-1.917q.291 0 .533-.15.25-.15.4-.391a1.03 1.03 0 0 0 0-1.075q-.15-.25-.4-.4a1.034 1.034 0 0 0-1.075 0q-.24.15-.391.4a1.034 1.034 0 0 0 0 1.075q.15.24.391.391.25.15.542.15m-7-4.583a2.93 2.93 0 0 1-1.508-.4A3.14 3.14 0 0 1 7.9 11.267a2.95 2.95 0 0 1-.4-1.517q0-.816.417-1.5.416-.684 1.1-1.092A2.84 2.84 0 0 1 10.5 6.75q.825 0 1.5.408.684.4 1.092 1.084.408.675.408 1.508a2.9 2.9 0 0 1-.408 1.517q-.409.674-1.092 1.083-.675.4-1.5.4m0-1.917q.291 0 .533-.15.25-.15.4-.391a1.03 1.03 0 0 0 0-1.075q-.15-.25-.4-.4a1.034 1.034 0 0 0-1.075 0q-.24.15-.391.4a1.034 1.034 0 0 0 0 1.075q.15.24.391.391.25.15.542.15"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "deposit-gold_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 26 -12.8908 0 13.89 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCA31E"
})), /*#__PURE__*/React.createElement("filter", {
  id: "deposit-gold_svg__a",
  width: 74,
  height: 74,
  x: -23,
  y: -24,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_8905_33614"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0156863 0 0 0 0 0.054902 0 0 0 0 0.164706 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur_8905_33614",
  result: "effect2_dropShadow_8905_33614"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_8905_33614",
  result: "shape"
})))));
export default SvgDepositGold;